/**
 * What she typed, as minutes past midnight - or null.
 *
 * "I'm not sure why but I can't get this 10 am new client booked it wants me
 *  to pick a time it's not letting me override ... I can do 9:30 but not 10 am"
 *
 * The field was <input type="time">, which on Windows renders hh:mm AM/PM and
 * reports an EMPTY value until the AM/PM segment is filled in. Her screens
 * show "10:00 --", so the override read as nothing typed at all and the Book
 * button stayed grey. 9:30 worked because that was a button, not typing.
 *
 * So the time is now plain text and read leniently: "10", "10:00", "10am",
 * "2:30 pm", "1430" all land where she means. With no am/pm, the practice's
 * own day decides: 8-11 is morning, 12 and 1-7 are afternoon, which covers
 * every hour she is open and is what anybody at a desk means by "book him at
 * 2".
 */
export function readTypedTime(input: string): number | null {
  const t = input.trim().toLowerCase().replace(/\./g, "");
  if (!t) return null;
  const m = /^(\d{1,2})(?::?(\d{2}))?\s*(am|pm|a|p)?$/.exec(t);
  if (!m) return null;
  let h = Number(m[1]);
  const mins = m[2] === undefined ? 0 : Number(m[2]);
  if (mins > 59) return null;
  // "1430" with no separator is half past two.
  if (m[2] === undefined && m[1]!.length === 4) {
    h = Number(m[1]!.slice(0, 2));
    const mm = Number(m[1]!.slice(2));
    if (h > 23 || mm > 59) return null;
    return h * 60 + mm;
  }
  const meridiem = m[3]?.[0];
  if (meridiem === "p") { if (h < 12) h += 12; }
  else if (meridiem === "a") { if (h === 12) h = 0; }
  else if (h >= 1 && h <= 7) h += 12;   // nobody books 3am
  if (h > 23) return null;
  return h * 60 + mins;
}
